<template>
    <div v-if="show">
        <v-form ref="form" v-model="validForm" lazy-validation>
            <v-col>
                <HeaderCheckList
                    title="Hidrômetros"
                    :click="() => create()"
                />
            </v-col>
            <v-row>
                <div v-for="hyd, i in list">
                    <CardCheckList
                    :loading="loadingIndex === i"
                    :view="() => edit(i)"
                    :remove="() => remove(i)"
                >
                    <template v-slot:content>
                        <v-row>
                            <v-col cols="12"
                                style="
                                    font-size: 15px;
                                    color: black;
                                    text-align: center;
                                    font-weight: 600;
                                "
                            >
                                {{ hyd.locale }}
                            </v-col>
                            <v-col cols="12" style="
                                    font-size: 12px;
                                    color: black;
                                    text-align: center;
                                    font-weight: 600;
                                ">
                                {{ hyd.supply }} / {{ getTextHydrometerModel(hyd.model) }}
                            </v-col>
                        </v-row>
                    </template>
                </CardCheckList>
                </div>
            </v-row>
            <v-dialog transition="dialog-top-transition" v-model="dialog" persistent max-width="500px">
                <v-card>
                    <v-toolbar color="primary" dark> <span class="text-h5">Adicionar Hidrômetro</span></v-toolbar>
                    <v-card-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text style="padding-bottom: 0px;">
                        <v-form   
                            ref="hydrometerForm"
                            v-model="isValidForm"
                            lazy-validation
                        >
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field 
                                        v-model="hydrometer.locale" 
                                        outlined 
                                        label="Local" 
                                        type="text"
                                        required :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="8">
                                    <v-select 
                                        v-model="hydrometer.supply" 
                                        outlined 
                                        label="Abastecimento"
                                        :items="optionsSupply" 
                                        required 
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-select 
                                        v-model="hydrometer.model" 
                                        outlined 
                                        label="Modelo Hidrômetro"
                                        :items="optionsHydrometer" 
                                        required 
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6" v-if="isManagementProposal">
                                    <v-select 
                                        v-model="hydrometer.ifInstallation" 
                                        outlined 
                                        label="Realizar instalação?"
                                        :items="selectedIf" 
                                        required 
                                    />
                                </v-col>
                                <v-col cols="6" v-if="isManagementProposal">
                                    <v-select 
                                        v-model="hydrometer.ifLoan" 
                                        outlined 
                                        label="Comodato?"
                                        :items="selectedIf" 
                                        required 
                                    />
                                </v-col>
                                <v-col cols="12" :sm="12">
                                      <v-textarea 
                                        v-model="hydrometer.comments" 
                                        outlined 
                                        label="Observação" 
                                        type="text"
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row dense class="mt-2">
                            <v-col cols="6">
                                <InputFiles
                                    :key="refInput"
                                    title="Foto 1"
                                    :refInput="refInput"
                                    :loading="false"
                                    :fileTypes="['image']"
                                    :showFile="hydrometer.file_photo"
                                    @change:file="(file) => handleImageChange(file, 1)"
                                />
                            </v-col>
                            <v-col cols="6">
                                <InputFiles
                                    :key="refInput + 1"
                                    title="Foto 2"
                                    :refInput="refInput + 1"
                                    :loading="false"
                                    :fileTypes="['image']"
                                    :showFile="hydrometer.file_photo2"
                                    @change:file="(file) => handleImageChange(file, 2)"
                                />
                            </v-col>
                        </v-row>
                        
                    </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDialog()">
                    Cancelar
                    </v-btn>
                    <v-btn :disabled="!isValidForm" color="blue darken-1" text @click="save()"> Adicionar </v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>
    </div>
</template>
  
<script>
import HeaderCheckList from "@/components/Projects/Diagnostic/Tabs/CheckList/HeaderCheckList.vue"
import CardCheckList from "@/components/Projects/Diagnostic/Tabs/CheckList/CardCheckList.vue"
import DiagnosticStorage from '@/services/storage/DiagnosticStorage';
import InputFiles from "@/components/Forms/Input/input-files.vue";
import cloneDeep from 'lodash/cloneDeep';

import Rules from "@/utils/Rules";

const newHydrometer = () => {
    return {
        locale: "",
        supply: "",
        model: "",
        file_photo: null,
        path_photo: null,
        file_photo2: null,
        path_photo2: null,
        comments: "",
        ifInstallation: false,
        ifLoan: false,
    }
}

export default {
    name: "HydrometerList",
    
    components: {
        HeaderCheckList,
        CardCheckList,
        InputFiles
    },
    
    props: {
        show: {
            type: Boolean,
            default: true
        },
        list: {
            type: Array,
            default: () => ([]),
        },
        add: {
            type: Function,
            default: (hydrometer, index) => {}
        },
        remove: {
            type: Function,
            default: (index) => {}
        },
        desiredProposal: {
            type: Array,
            default: () => []
        }
    },
    
    data: () => ({
        loadingIndex: -1,
        isValidForm: false,
        refInput: new Date().getTime(),
        validForm: true,
        dialog: false,
        file: null,
        index: -1,
        optionsSupply: ["Poço", "Concessionária", "Caminhão Pipa"],
        optionsHydrometer: [
            { text: "DN 15", value: "dn_15" },
            { text: "DN 20", value: "dn_20" },
            { text: "DN 25", value: "dn_25" },
            { text: "DN 32", value: "dn_32" },
            { text: "DN 40", value: "dn_40" },
            { text: "DN 50", value: "dn_50" },
            { text: "DN 80", value: "dn_80" },
            { text: "DN 110", value: "dn_110" },
        ],
        selectedIf:[
            {text:"Sim", value:true},
            {text:"Não", value:false},
        ],
        hydrometer: newHydrometer(),
    }),

    computed: {
        rulesRequired() {
            return Rules.required();
        },
        isManagementProposal(){
            return this.desiredProposal.includes("management")
        },
    },
    methods: {
        create() {
            this.index = -1
            this.hydrometer = newHydrometer()
            this.refInput = new Date().getTime()
            this.dialog = true
        },
        handleImageChange(file, photoNumber) {
            const fileKey = photoNumber === 1 ? 'file_photo' : 'file_photo2';
            const pathKey = photoNumber === 1 ? 'path_photo' : 'path_photo2';
            
            // Cláusula de guarda para evitar loop de eventos (ping-pong)
            if (this.hydrometer[fileKey] === file) return;

            if (!file) {
                this.$set(this.hydrometer, pathKey, null);
                this.$set(this.hydrometer, fileKey, null);
            } else {
                this.$set(this.hydrometer, pathKey, null);
                this.$set(this.hydrometer, fileKey, file);
            }
        },
        clearImageState() {
            if (this.hydrometer) {
                this.hydrometer.file_photo = null
                this.hydrometer.path_photo = null
                this.hydrometer.file_photo2 = null
                this.hydrometer.path_photo2 = null
            }
        },
        async edit(index) {
            try {
                this.loadingIndex = index;
                this.index = index;
                this.hydrometer = cloneDeep(this.list[index])
                
                // Forçar a existência das propriedades para garantir reatividade total
                if (!this.hydrometer.hasOwnProperty('file_photo')) this.$set(this.hydrometer, 'file_photo', null)
                if (!this.hydrometer.hasOwnProperty('file_photo2')) this.$set(this.hydrometer, 'file_photo2', null)
                
                // Regenerar o refInput para garantir que o InputFiles seja resetado corretamente via :key
                this.refInput = new Date().getTime()
                
                // Carregar as imagens antes de abrir o modal
                if (this.hydrometer.path_photo) {
                    try {
                        const file1 = await DiagnosticStorage.downloadImg(this.hydrometer.path_photo)
                        this.$set(this.hydrometer, 'file_photo', file1)
                    } catch (error) {
                        console.error('Erro ao carregar imagem 1:', error)
                        this.$set(this.hydrometer, 'file_photo', null)
                    }
                }
                if (this.hydrometer.path_photo2) {
                    try {
                        const file2 = await DiagnosticStorage.downloadImg(this.hydrometer.path_photo2)
                        this.$set(this.hydrometer, 'file_photo2', file2)
                    } catch (error) {
                        console.error('Erro ao carregar imagem 2:', error)
                        this.$set(this.hydrometer, 'file_photo2', null)
                    }
                }
                
                // Aguardar o próximo tick para garantir que o modal seja renderizado com a imagem
                await this.$nextTick()
                this.dialog = true
            } catch (error) {
                console.error('Erro ao editar hidrômetro:', error)
            } finally {
                this.loadingIndex = -1;
            }
        },
        save() {
            if (!this.$refs.hydrometerForm.validate()) return
            this.add(cloneDeep(this.hydrometer), this.index)
            this.dialog = false
            this.clearImageState()
        },
        closeDialog() {
            this.dialog = false
            this.clearImageState()
            // Limpar URLs de objeto para evitar vazamentos de memória
            if (this.hydrometer) {
                this.hydrometer.file_photo = null
                this.hydrometer.file_photo2 = null
            }
        },
        getTextHydrometerModel(value) {
            return this.optionsHydrometer.find((options) => options.value === value).text
        }
    },

    watch: {

    },

};
</script>
  
<style scoped>

</style>